import { customScrollMinimal } from '@toggle/design-system';
import styled from 'styled-components';

import { ALFRED_FOOTER_SPACER_HEIGHT_PX } from '~/components/alfred-footer/AlfredFooter.styles';

export const Root = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  min-height: 0;
  overflow-x: auto;
`;

export const Content = styled.span<{ $hasFooter?: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  ${customScrollMinimal};
  ${({ $hasFooter }) =>
    $hasFooter && `padding-bottom: ${ALFRED_FOOTER_SPACER_HEIGHT_PX}px;`}
`;
